module.exports = ".wrapper {\n  padding: 30px; }\n\nimg {\n  max-height: 100px; }\n"